import './UserGuideTopicLanguageContentVideo.scss'

type ComponentProps = {
  location: string
  title: string
}

const UserGuideTopicLanguageContentVideo = (props:ComponentProps) => {

  return (
    
    <div id='user-guide-topic-language-content-video'>
      <iframe 
          id = 'user-guide-topic-language-content-video-iframe'
          src = {props.location} 
          title = {props.title}
          allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share;"
          >
      </iframe>
    </div>
  )
}

export default UserGuideTopicLanguageContentVideo